import * as React from "react";
import XDiv from "../../core/XDiv";
import Icon from "../../core/MyIcon";

import { Stack, Tooltip } from "@mui/material";
import { SettingsOutlined } from "@mui/icons-material";
import { TUseXElement } from "../../../hooks/useXElement";
import { SECONDARY_COLOR } from "../../../utils/constants/common/utils";
import { XGUIHeaderBreadCrumb } from "./XGUIHeaderBreadCrumb";

export const X_PAGE_SETTINGS: TUseXElement<any> = {
  childOf: null,
  hierachy: "XPage",
  name: "XPage",
  index: "XPage",
  value: {},
  hasChildren: false,
  elementsIndexes: [],
};

export const XGUIHeader: React.FC<{
  selectedElement?: TUseXElement<any>;
  setSelectedIndex: (id: null | string) => void;
}> = ({ selectedElement = X_PAGE_SETTINGS, setSelectedIndex }) => {
  return (
    <XDiv className="XGUI-Header">
      <Stack direction="row" alignItems="stretch" height="100%">
        <Tooltip
          title={selectedElement.name === "XPage" ? "Parametre" : "Fermer"}
        >
          <button
            className="XGUI-Drag-Handler"
            style={{
              background:
                selectedElement.name === "XPage" ? "black" : SECONDARY_COLOR,
            }}
            onClick={() => {
              const other = document.querySelector("[data-x-selected='true']");

              if (other) other.removeAttribute("data-x-selected");

              setSelectedIndex(null);
            }}
          >
            {selectedElement.name === "XPage" ? (
              <SettingsOutlined sx={{ color: "white", fontSize: 20 }} />
            ) : (
              <Icon name={"close"} color="white" />
            )}
          </button>
        </Tooltip>
        {selectedElement.childOf && (
          <Tooltip title={"Parent"}>
            <button
              className="XGUI-Drag-Handler"
              onClick={() => {
                const other = document.querySelector(
                  "[data-x-selected='true']"
                );

                if (other) other.removeAttribute("data-x-selected");

                setSelectedIndex(selectedElement.childOf);
              }}
            >
              <Icon name={"move_up"} color="white" />
            </button>
          </Tooltip>
        )}
      </Stack>
      <XGUIHeaderBreadCrumb selectedElement={selectedElement} />
    </XDiv>
  );
};
